export default {
  placeholder: 'Wybierz kolor',
  color: {
    105: 'Szara 50-tka',
    106: 'Szary 100',
    107: 'Szary 200',
    108: 'Szary 300',
    109: 'Szary 400',
    110: 'Szary 500',
    111: 'Szary 600',
    112: 'Szary 700',
    113: 'Szary 800',
    114: 'Szary 900',
    115: 'Niebieski 50',
    116: 'Niebieski 100',
    117: 'Niebieski 200',
    118: 'Niebieski 300',
    119: 'Niebieski 400',
    120: 'Niebieski 500',
    121: 'Niebieski 600',
    122: 'Niebieski 700',
    123: 'Niebieski 800',
    124: 'Niebieski 900',
    125: 'Zielona 50',
    126: 'Zielona 100',
    127: 'Zielony 200',
    128: 'Zielony 300',
    129: 'Zielony 400',
    130: 'Zielony 500',
    131: 'Zielony 600',
    132: 'Zielony 700',
    133: 'Zielony 800',
    134: 'Zielony 900',
    135: 'Żółty 50',
    136: 'Żółty 100',
    137: 'Żółty 200',
    138: 'Żółty 300',
    139: 'Żółty 400',
    140: 'Żółty 500',
    141: 'Żółty 600',
    142: 'Żółty 700',
    143: 'Żółty 800',
    144: 'Żółty 900',
    145: 'Cyjan 50',
    146: 'Cyjan 100',
    147: 'Cyjan 200',
    148: 'Cyjan 400',
    149: 'Cyjan 500',
    150: 'Cyjan 600',
    151: 'Cyjan 700',
    152: 'Cyjan 800',
    153: 'Cyjan 900',
    154: 'Różowy 50',
    155: 'Różowy 100',
    156: 'Różowy 200',
    157: 'Różowy 300',
    158: 'Różowy 400',
    159: 'Różowy 500',
    160: 'Różowy 600',
    161: 'Różowy 700',
    162: 'Różowy 800',
    163: 'Różowy 900',
    164: 'Indygo 50',
    165: 'Indygo 100',
    167: 'Indygo 200',
    168: 'Indygo 300',
    169: 'Indygo 400',
    170: 'Indygo 500',
    171: 'Indygo 600',
    172: 'Indygo 700',
    173: 'Indygo 800',
    174: 'Indygo 900',
    175: 'Teal 50',
    176: 'Teal 100',
    177: 'Teal 200',
    178: 'Teal 300',
    179: 'Teal 400',
    180: 'Teal 500',
    181: 'Teal 600',
    182: 'Teal 700',
    183: 'Teal 800',
    184: 'Teal 900',
    185: 'Pomarańczowy 50',
    186: 'Pomarańczowy 100',
    187: 'Pomarańczowy 200',
    188: 'Pomarańczowy 400',
    189: 'Pomarańczowy 500',
    190: 'Pomarańczowy 600',
    191: 'Pomarańczowy 700',
    192: 'Pomarańczowy 800',
    193: 'Pomarańczowy 900',
    194: 'Niebieskoszary 50',
    195: 'Niebieskoszary 100',
    196: 'Niebieskoszary 200',
    197: 'Niebieskoszary 300',
    198: 'Niebieskoszary 400',
    199: 'Niebieskoszary 500',
    200: 'Niebieskoszary 600',
    201: 'Niebieskoszary 700',
    202: 'Niebieskoszary 800',
    203: 'Niebieskoszary 900',
    204: 'Fioletowy 50',
    205: 'Fioletowy 100',
    206: 'Fioletowy 200',
    207: 'Fioletowy 300',
    208: 'Fioletowy 400',
    209: 'Fioletowy 500',
    210: 'Fioletowy 600',
    211: 'Fioletowy 700',
    212: 'Fioletowy 800',
    213: 'Fioletowy 900',
    214: 'Czerwona 50',
    215: 'Czerwony 100',
    216: 'Czerwony 200',
    217: 'Czerwony 300',
    218: 'Czerwony 400',
    219: 'Czerwony 500',
    220: 'Czerwony 600',
    221: 'Czerwony 700',
    222: 'Czerwony 800',
    223: 'Czerwony 900',
    custom: 'Zwyczaj',
  },
};
